import { render, staticRenderFns } from "./Aggiungi_tappa.vue?vue&type=template&id=6e8c7ce2&scoped=true&"
import script from "./Aggiungi_tappa.vue?vue&type=script&lang=js&"
export * from "./Aggiungi_tappa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c7ce2",
  null
  
)

export default component.exports